var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.516,
    height: 21.577,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3908"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2430"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2422"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2421"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4797",
    d: "M21.8 14.193v3.316a5.735 5.735 0 01-.026.7l.031-.229a3.03 3.03 0 01-.206.74l.086-.206a3.016 3.016 0 01-.251.463 4.367 4.367 0 01-.086.123c-.086.12.134-.16.043-.054-.06.071-.123.14-.189.209s-.129.12-.194.177c-.137.12.163-.117.04-.029a1.212 1.212 0 01-.109.074 2.781 2.781 0 01-.48.26l.206-.086a3.029 3.029 0 01-.74.206l.229-.031a5.954 5.954 0 01-.748.026H3.772a3.236 3.236 0 01-.406-.026l.229.031a3.029 3.029 0 01-.74-.206l.206.086a3.006 3.006 0 01-.463-.251 4.367 4.367 0 01-.123-.086c-.12-.086.16.134.054.043-.071-.06-.14-.123-.209-.189s-.12-.129-.177-.194c-.12-.137.117.163.029.04a1.219 1.219 0 01-.074-.109 2.781 2.781 0 01-.26-.48l.086.206a3.028 3.028 0 01-.206-.74l.031.229a11.312 11.312 0 01-.026-1.46v-2.557a.857.857 0 00-1.714 0v3.067a5.241 5.241 0 00.18 1.7 3.843 3.843 0 002.3 2.377 5.689 5.689 0 002.094.226h15.173a3.8 3.8 0 002.737-1.18 3.843 3.843 0 001.023-2.617v-3.576a.867.867 0 00-.857-.857.877.877 0 00-.857.86z",
    fill: "#c6c6c6"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2429"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2424"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2423"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4798",
    d: "M12.618 14.917V2.588c0-.568.011-1.137 0-1.705V.857a.857.857 0 10-1.714 0v12.329c0 .568-.011 1.137 0 1.705v.026a.857.857 0 001.714 0z",
    fill: "#c6c6c6"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2426"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2425"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4799",
    d: "M11.156 1.465l1.651 1.651 2.634 2.634.606.606a.856.856 0 001.211-1.211l-1.651-1.651L12.973.86l-.606-.606a.856.856 0 10-1.211 1.211z",
    fill: "#c6c6c6"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2428"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2427"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4800",
    d: "M11.156.255L9.505 1.906 6.871 4.54l-.606.606a.856.856 0 101.211 1.211l1.651-1.651 2.634-2.634.606-.606A.856.856 0 0011.156.255z",
    fill: "#c6c6c6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.27aa3a51a183f8443365e7250358a245.svg";
export { ForwardRef as ReactComponent };